export default "__VITE_ASSET__BVmkkyDV__"